<!-- floating Input -->

<div [dir]="biService.getDir() ? 'rtl': 'ltr'">
    <mat-form-field [style]="Control.Style" appearance="outline" >
        <mat-label>{{Control?.DisplayName ||"" | translate}}</mat-label>
        <!-- TextAfterInput -->
        <BI-grid-layout-item [row]="1" [col]="2" *ngIf="Control.TextAfterInput">
            <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                <BI-grid-layout-item [row]="1" [col]="1">
                    <ng-container *ngTemplateOutlet="InputTypes"></ng-container>
                </BI-grid-layout-item>

                <BI-grid-layout-item [row]="1" [col]="2">
                    <span>{{ Control.TextAfterInput}} </span>
                </BI-grid-layout-item>
            </BI-grid-layout>
        </BI-grid-layout-item>

        <!-- TemplateRef -->
        <BI-grid-layout-item [row]="1" [col]="2" *ngIf="Control.TemplateRef">
            <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                <BI-grid-layout-item [row]="1" [col]="1">

                    <ng-container *ngTemplateOutlet="InputTypes"></ng-container>
                </BI-grid-layout-item>

                <BI-grid-layout-item [row]="1" [col]="2">
                    <ng-container [ngTemplateOutlet]="Control.TemplateRef">
                    </ng-container>
                </BI-grid-layout-item>
            </BI-grid-layout>
        </BI-grid-layout-item>

        <!-- Input only -->
        <BI-grid-layout-item [row]="1" [col]="2" *ngIf="!Control.TextAfterInput&&!Control.TemplateRef">
            <ng-container *ngTemplateOutlet="InputTypes"></ng-container>
        </BI-grid-layout-item>

        <!--  InputTypes-->
        <ng-template #InputTypes>
            <ng-container *ngIf="Type=='text'">
                <input matInput [formControl]="this.FormControl" [id]="'input_'+Control.Name" type="text"
                    [mask]="Control?.Mask" [showMaskTyped]="Control?.Mask? true: false" />
            </ng-container>

            <ng-container *ngIf="Type=='password'">
                <input matInput [formControl]="this.FormControl" [id]="'input_'+Control.Name" type="password"
                    [mask]="Control?.Mask" [showMaskTyped]="Control?.Mask? true: false" />
            </ng-container>

            <ng-container *ngIf="Type=='number'">
                <input matInput [formControl]="this.FormControl" [id]="'input_'+Control.Name" type="number"    />
            </ng-container>

            <ng-container *ngIf="Type=='textarea'||Type=='logText'">
                <input matInput [formControl]="this.FormControl" [id]="'input_'+Control.Name"
                    [mask]="Control?.Mask" [showMaskTyped]="Control?.Mask? true: false" />
            </ng-container>

        </ng-template>

        <validation-error-tool-tip matSuffix [FormControl]="FormControl" [Control]="Control">
        </validation-error-tool-tip>

    </mat-form-field>

</div>



